import React from "react";
import { BlockMath, InlineMath } from "react-katex";
import FractionInput from "../../../../components/inputs/FractionInput";
import LighthouseDiagram from "../../../../components/diagrams/LighthouseDiagram"; // placeholder – przygotujemy osobno

function randomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function generateTask() {
  const angle = randomInt(10, 30); // kąt padania światła
  const height = [20, 30, 35, 40, 45, 50][Math.floor(Math.random() * 6)]; // wysokość latarni
  const radians = (angle * Math.PI) / 180;
  const range = Number((height / Math.tan(radians)).toFixed(2)); // zasięg światła

  return {
    type: "LighthouseRangeTask",
    angle,
    height,
    range,
    data: { angle, height, range }
  };
}

export function renderTask({ angle, height }) {
  return (
    <div className="space-y-2">
      <p>
        Światło z latarni o wysokości{" "}
        <InlineMath math={`${height}\\ \\text{m}`} inline /> pada na taflę wody pod kątem{" "}
        <InlineMath math={`${angle}^\\circ`} inline /> względem poziomu.
        <br />
        Oblicz, jaki jest zasięg światła – czyli odległość od podstawy latarni do miejsca,
        w którym światło dotyka tafli, z dokładnością do{" "}
        <InlineMath math={`0{,}01\\ \\text{m}`} inline />.
      </p>
      <LighthouseDiagram angle={angle} height={height} range={null} />
    </div>
  );
}

export function renderInput(task, userAnswer, onChange, disabled) {
  return (
    <FractionInput
      value={userAnswer}
      onChange={onChange}
      disabled={disabled}
      label="x"
      suffixLatex="\text{m}"
    />
  );
}

export function renderAnswer({ range }) {
  const formatted = range.toFixed(2);
  return <InlineMath math={`${formatted}\\ \\text{m}`} />;
}

export function checkAnswer(data, userAnswer) {
  const expected = data.range;
  const given = userAnswer?.parsed ?? Number(userAnswer);
  if (!isFinite(given)) return false;
  return Math.abs(given - expected) <= 0.02;
}

export function renderExplanation(input) {
  const data = input?.data ?? input;
  const { angle, height, range } = data;
  const tan = Math.tan((angle * Math.PI) / 180).toFixed(4);
  const raw = (height / Math.tan((angle * Math.PI) / 180)).toFixed(4);
  const rounded = range.toFixed(2);

  return (
    <div className="space-y-4 text-left">
      <div>
        <strong>Krok 1:</strong> Zapisujemy związek między wysokością a zasięgiem:
        <BlockMath math={`\\tan(${angle}^\\circ) = \\frac{${height}}{x}`} />
      </div>
      <div>
        <strong>Krok 2:</strong> Przekształcamy wzór:
        <BlockMath math={`x = \\frac{${height}}{\\tan(${angle}^\\circ)}`} />
      </div>
      <div>
        <strong>Krok 3:</strong> Podstawiamy wartość tangensa:
        <BlockMath math={`x \\approx \\frac{${height}}{${tan}} = ${raw}`} />
      </div>
      <div>
        <strong>Krok 4:</strong> Zaokrąglamy wynik:
        <BlockMath math={`x \\approx ${rounded}\\ \\text{m}`} />
      </div>
    </div>
  );
}

export function renderUserAnswer(userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object" || !userAnswer.raw) {
    return <i>(brak odpowiedzi)</i>;
  }

  const formatted = userAnswer.raw
    .replaceAll("*", "\\cdot ")
    .replaceAll("/", "\\div ")
    .replaceAll("sqrt", "\\sqrt")
    .replaceAll("-", " - ")
    .replaceAll("+", " + ");

  return <InlineMath math={`${formatted}\\ \\text{m}`} />;
}
